<div class="container" *ngIf="item?.cells">

  <div *ngIf="!item?.cells[this.fieldDefinition.key]?.metaData?.IsReadOnly" class="wrappers">
    <a class="link-color" (click)="onClicked('Edit')">
      <div
        title="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
        [innerHTML]="item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].displayText | apiColourHtml) : '' | sanitizeHtml">
      </div>
    </a>

    <button
      (click)="onClicked('Refresh')"
      *ngIf="item.cells[this.fieldDefinition.key]?.metaData?.EnableResetIcon"
      class="icon-dropdown-button" matTooltip="Remove" mat-icon-button>
      <i class="fa-solid fa-arrows-rotate"></i>
    </button>
  </div>

  <div *ngIf="item?.cells[this.fieldDefinition.key].metaData?.IsReadOnly" class="no-link"
    title="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
    [innerHTML]="item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].displayText | apiColourHtml) : '' | sanitizeHtml">
  </div>

</div>
